var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1717.71 1035.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fffaff;\n        stroke-miterlimit: 10;\n        stroke-width: 50px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.77,412.26l-341.93-341.93c-58.58-58.58-153.55-58.58-212.13,0l-235.16,235.16-236.56-236.56c-28.13-28.13-66.28-43.93-106.07-43.93s-77.94,15.8-106.07,43.93L68.93,410.86c-58.58,58.58-58.58,153.55,0,212.13,58.58,58.58,153.55,58.58,212.13,0l235.86-235.86,224.37,224.37c3.54,4.46,7.36,8.77,11.49,12.89,29.29,29.29,67.67,43.94,106.07,43.93,38.38,0,76.78-14.65,106.07-43.93l235.86-235.86,235.86,235.86c29.29,29.29,67.68,43.93,106.07,43.93s76.78-14.64,106.07-43.93c58.58-58.58,58.58-153.55,0-212.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1683.05,571.38c-.86,2.27-1.77,4.53-2.75,6.77.97-2.24,1.89-4.5,2.75-6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.64,624.4l-106.07-106.07-129.79,129.79-129.79-129.79-106.07,106.07c-29.29,29.29-67.68,43.93-106.07,43.93-38.39,0-76.77-14.64-106.07-43.93-4.12-4.12-7.94-8.43-11.49-12.89l-93.88-93.88-236.56,236.56c-58.58,58.58-58.58,153.55,0,212.13s153.55,58.58,212.13,0l235.86-235.86,235.86,235.86c29.29,29.29,67.68,43.93,106.07,43.93s76.78-14.64,106.07-43.93l341.93-341.93c-29.29,29.29-67.68,43.93-106.07,43.93s-76.78-14.64-106.07-43.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.77,412.26c24.71,24.71,39,55.9,42.86,88.11-3.86-32.2-18.15-63.39-42.86-88.11,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1691.64,500.37c.43,3.58.73,7.17.9,10.76-.17-3.6-.47-7.19-.9-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1686.53,561.04c-.69,2.32-1.43,4.63-2.23,6.92.8-2.29,1.54-4.6,2.23-6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1692.54,525.53c-.11,2.4-.29,4.79-.51,7.18.23-2.39.4-4.79.51-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1690.61,543.43c-.6,3.56-1.33,7.1-2.19,10.61.86-3.52,1.59-7.06,2.19-10.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOutline);
export default __webpack_public_path__ + "static/media/NoOutline.bd5302f66e2e9edf39cd029391dc08bb.svg";
export { ForwardRef as ReactComponent };